import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from './MainNav.module.scss';
import { useAuthContext } from '../../../features/authentication/contexts/AuthContext';
import { AppColor, Fonts } from '../../../types/Constants';
import UserProfileDialog from '../../../features/authentication/dialogs/UserProfileDialog';

function MainNav() {

  const auth = useAuthContext();
  const [isOpenUserProfile, setIsOpenUserProfile] = useState<boolean>(false);

  return (
    <nav className={styles.mainNav}>
      <div className={styles.mainNav_rightSide}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              p: 1,
              mr: 1,
              borderRadius: 2,
              "&:hover": { backgroundColor: AppColor.orangeBoldBackground },
            }}
            onClick={() => setIsOpenUserProfile(true)}
          >
            <Box
              sx={{
                display: "flex",
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: AppColor.baseOrange,
                color: "white",
              }}
            >
              <PersonOutlineOutlinedIcon
                sx={{ color: "white", fontSize: 18, fontWeight: Fonts.LIGHT }}
              />
            </Box>
            <Box sx={{ ml: 2, mt: "2px" }}>
              <Typography className={styles.mainNav__rightSideItem}>
                {auth.preferredUserName ?? auth.user}
              </Typography>
            </Box>
            <Box
              sx={{
                ml: 1,
                mt: "3px",
                display: "flex",
                color: "white",
              }}
            >
              <ExpandMoreIcon />
            </Box>
          </Box>
        </Box>
        <UserProfileDialog
          isOpen={isOpenUserProfile}
          onClose={() => setIsOpenUserProfile(false)}
          isSSO={auth.isSSOUser}
        />
      </div>
    </nav>
  );
}

export default MainNav;